import React, { FC, memo } from 'react'
import { InputComponent } from 'LibNeo'
import { FieldNames } from 'Src/constants/FieldNames'
import { Validators } from 'Modules'
import { SpecialInputPropsModel } from 'LibNeo/models'

export const PostalCodeInput: FC<SpecialInputPropsModel> = memo((props): JSX.Element => {
	return (
		<InputComponent
			{...props}
			fieldName={props?.fieldName || FieldNames.POSTAL_CODE}
			fieldOptions={{
				rules: [
					{
						validator: Validators.checkPassportNumber({
							required: props?.required,
							messageError: 'lib.postal_code',
						}),
					},
				],
				initialValue: props?.initialValue,
			}}
			dataQa={props?.dataQa || 'postal-code-input'}
			label={props?.label ?? 'lib.postal_code_lib'}
			placeholder="lib.postal_code"
			format="######"
			mask=" "
		/>
	)
})
